import "./rewards-hero-banner.css";
import { createMarkupAfterTitle, createMarkupBeforeTitle, addYellowBackground, copyWidget } from "utils/storefront/rewards";

export default (element, data) => {
  const { log_in_sub_text, log_out_sub_title, log_out_button_link, log_out_button_title, log_in_eyebrow_text, customer } = data;

  const intervalId = setInterval(() => {
    const yotpoWidget = element.querySelector(".yotpo-widget-my-rewards-widget");
    const containerWithText = element.querySelector(".yotpo-customized-text.yotpo-headline");
    const pointEl = element.querySelector(".yotpo-customized-text.yotpo-description .yotpo-inner-text");

    if (containerWithText && yotpoWidget) {
      clearInterval(intervalId);

      containerWithText.insertAdjacentElement(
        "afterend",
        createMarkupAfterTitle(customer, log_in_sub_text, log_out_sub_title, log_out_button_link, log_out_button_title)
      );
      containerWithText.insertAdjacentElement("beforebegin", createMarkupBeforeTitle(customer, log_in_eyebrow_text));

      if (customer) {
        addYellowBackground(pointEl);
      }

      copyWidget(yotpoWidget);
    }
  }, 500);


  const init = () => {};
  init();
};
